var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3001,
    cy: 18.7,
    r: 18.7,
    fill: "#EDEEFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_13530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0236 15.5853V16.8371",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1373 15.5853V16.8371",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9908 24.0723C14.8223 21.933 16.7484 20.7688 19.58 20.7688C22.4115 20.7688 24.3376 21.933 25.169 24.0723",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5804 30.6052C27.0197 30.6052 31.2043 26.4206 31.2043 18.9813C31.2043 11.542 27.0197 7.35742 19.5804 7.35742C12.1411 7.35742 7.95654 11.542 7.95654 18.9813C7.95654 26.4206 12.1411 30.6052 19.5804 30.6052Z",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_13530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9617,
    height: 26.9617,
    fill: "white",
    transform: "translate(6.09998 5.50043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile4);
export default __webpack_public_path__ + "static/media/smile-4.5c925d3e249f340122d1128fb03f918e.svg";
export { ForwardRef as ReactComponent };